import { EffectTilt } from '@shared/components'
import { copy } from '@shared/utils'

export class PageController {
  private readonly actions = new Map([['copy', this.copy]])

  constructor() {
    document.addEventListener('click', this.onClick)
    // this.enableEffectTilt()
  }

  private onClick = (event: MouseEvent) => {
    const element = (event.target as Element).closest<HTMLElement>('[data-action]')
    if (!element) return
    const action = this.actions.get(element.dataset.action!)
    action?.call(this, element)
  }

  private async copy(element: HTMLElement) {
    await copy(element)
  }

  enableEffectTilt() {
    new EffectTilt(document.querySelector('.header__stamp')!)
  }
}
